// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__zplrn","consentsList":"PatientConsents_consentsList__32-sX","consentsListEmpty":"PatientConsents_consentsListEmpty__qFAr7"};